import { render, staticRenderFns } from "./WebResourceRequestList.vue?vue&type=template&id=35f58072&scoped=true"
import script from "./WebResourceRequestList.vue?vue&type=script&lang=ts"
export * from "./WebResourceRequestList.vue?vue&type=script&lang=ts"
import style0 from "./WebResourceRequestList.vue?vue&type=style&index=0&id=35f58072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f58072",
  null
  
)

export default component.exports